import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateBalanceAdjustmentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const createBalanceAdjustment = createAsyncThunk<string, CreateBalanceAdjustmentBody, { extra: Partial<Dependencies> }>(
  "balanceAdjustments/createBalanceAdjustment",
  async (balanceAdjustment: CreateBalanceAdjustmentBody, { extra: { adminRepository } }) => {
    return adminRepository!.createBalanceAdjustment(balanceAdjustment);
  },
);

export const resetCreateBalanceAdjustment = createAction("balanceAdjustments/resetCreateBalanceAdjustment");
